import React, { useEffect, useContext } from 'react';
import Header from "../../header/Header"
import { Wrapper } from "../../../common/styled-components/styled-components";
import FirstFold from "./first-fold/FirstFold";
import Testimonial from "./testimonial/Testimonials";
import { SemContext } from '../../../context/SemContext';
import LearningHabit from './learning-habit/LearningHabit';
import Playables from './playables/Playables';
import FeaturesList from './feature-list/feature-list';
import AwardsSection from './awards/awards-section';
import GamesSlide from './games-slider/games-slider';
import Statisctics from './stats/Statistics';
import ParentArea from './parent-area/ParentArea';
import Footer from "./footer-section/Footer";
import GradeContent from './grades-section/content';

const PromoPageV2 = (props) => {
  const { state, dispatch } = useContext(SemContext);
  useEffect(()=>{
    if (typeof (dataLayer) != "undefined") {
      trackToGtm(dataLayer, 'promo page loaded', 'promo page loaded');
    }
    props.trackPromoPageEvents("Promo Page Viewed");
  },[])

  return (
    <Wrapper noBackground={true}>
      <Header />
      <FirstFold settings={state.settings} trackPromoPageEvents={props.trackPromoPageEvents} />
      <Testimonial settings={state.settings} trackPromoPageEvents={props.trackPromoPageEvents} />
      <GradeContent trackPromoPageEvents={props.trackPromoPageEvents} settings={state.settings}/>
      <LearningHabit trackPromoPageEvents={props.trackPromoPageEvents} settings={state.settings}/>
      <Playables trackPromoPageEvents={props.trackPromoPageEvents} settings={state.settings}/>
      <Statisctics trackPromoPageEvents={props.trackPromoPageEvents} settings={state.settings}/>
      <GamesSlide trackPromoPageEvents={props.trackPromoPageEvents} settings={state.settings}/>
      <ParentArea trackPromoPageEvents={props.trackPromoPageEvents} settings={state.settings}/>
      <FeaturesList settings={state.settings} trackPromoPageEvents={props.trackPromoPageEvents}/>
      <AwardsSection trackPromoPageEvents={props.trackPromoPageEvents} settings={state.settings}/>
      <Footer/>
    </Wrapper>
  );
}

export default PromoPageV2